import { gql } from 'apollo-angular';

export var committee_calendar_fund_close_date_hover = gql`
  query committeeCalendarFundCloseDateHover($fund: ID!, $roles: Mixed) {
    fund(id: $fund) {
      id
      name
      legal_name
      ownedEntities {
        name
      }
      participants(hasRole: { column: NAME, operator: IN, value: $roles }) {
        organization {
          name
        }
        person {
          name
        }
        role {
          name
        }
      }
    }
  }
`;
